import { render, staticRenderFns } from "./RelatorioLogPeriodoFormacao.vue?vue&type=template&id=62d0e4bb"
import script from "./RelatorioLogPeriodoFormacao.vue?vue&type=script&lang=js"
export * from "./RelatorioLogPeriodoFormacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports